__turbopack_context__.v({
  "activeFilters": "QZGJXW_activeFilters",
  "container": "QZGJXW_container",
  "desktopSortByFilter": "QZGJXW_desktopSortByFilter",
  "dropdownsContainer": "QZGJXW_dropdownsContainer",
  "filtersContainer": "QZGJXW_filtersContainer",
  "hidden": "QZGJXW_hidden",
  "mobileButton": "QZGJXW_mobileButton",
  "mobileControls": "QZGJXW_mobileControls",
  "mobileFilterButton": "QZGJXW_mobileFilterButton" + " " + "QZGJXW_mobileButton",
  "mobileFilterButton--active": "QZGJXW_mobileFilterButton--active",
  "mobileSortButton": "QZGJXW_mobileSortButton" + " " + "QZGJXW_mobileButton",
});
